// 导出路径
// let exportUrl  = 'http://192.168.1.174:9000/'
let exportUrl  = 'https://www.sjxsm.com/uniform/admin/'
export default exportUrl